import { createPinia } from "pinia";
import piniaPersistedstate from "pinia-plugin-persistedstate";

// pinia persist
const pinia = createPinia();
pinia.use(piniaPersistedstate); // 注册持久化插件
export default pinia;
